import { render } from "./WorkerForms.vue?vue&type=template&id=996e36e8&scoped=true"
import script from "./WorkerForms.vue?vue&type=script&lang=js"
export * from "./WorkerForms.vue?vue&type=script&lang=js"

import "./WorkerForms.vue?vue&type=style&index=0&id=996e36e8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-996e36e8"]])

export default __exports__